"use strict";

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.promise");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = tryGetIPRangeName;

require("regenerator-runtime/runtime");

var _queryString = _interopRequireDefault(require("../pacman/queryString"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function tryGetIPRangeName(_x) {
  return _tryGetIPRangeName.apply(this, arguments);
}

function _tryGetIPRangeName() {
  _tryGetIPRangeName = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(visitor) {
    var mockip, res;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            mockip = (0, _queryString.default)(window.location.href, "mock-ip");
            console.log("mockip", mockip);

            if (visitor.ip) {
              _context.next = 17;
              break;
            }

            _context.prev = 3;
            _context.next = 6;
            return fetch('https://c1.ouisys.com/api/v1/ip' + (!!mockip ? "?mock-ip=".concat(mockip) : "")).then(function (x) {
              return x.json();
            });

          case 6:
            res = _context.sent;
            // return isIPInRange('37.200.146.28')
            visitor.ip = res.ip;
            visitor.ip_range_name = res.ip_range_name;
            return _context.abrupt("return", res.ip_range_name);

          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](3);
            console.warn("IP Lookup failed", _context.t0);

          case 15:
            _context.next = 18;
            break;

          case 17:
            return _context.abrupt("return", visitor.ip_range_name);

          case 18:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[3, 12]]);
  }));
  return _tryGetIPRangeName.apply(this, arguments);
}